export const getCacheKey = (schema, input) => `${schema.type}${input}`;
//# sourceMappingURL=cacheKey.js.map